import {
  Component,
  EventEmitter,
  Input,
  Output
  } from '@angular/core';
import { SelectableItem } from '../models/selectable-item';
import { SelectService } from '../services/select.service';
export class TreeSelectItemComponent {
/**
 * @return {?}
 */
public get isOpen() {
    return this.item.isOpen;
  }
public onTouchedCallBack: () => void;
public item: SelectableItem;
/**
 * @param {?} svc
 */
public constructor(
private svc: SelectService
  ) { }
/**
 * @param {?} $event
 * @return {?}
 */
public toggleOpen($event: any) {
    $event.stopPropagation();
    if (this.haveChildren) {
      this.item.isOpen = !this.item.isOpen;
    } else {
      this.select($event);
    }
  }
/**
 * @return {?}
 */
get allowParentSelection(): boolean {
    return this.svc.Configuration.allowParentSelection;
  }
/**
 * @return {?}
 */
get restructureWhenChildSameName(): boolean {
    return this.svc.Configuration.restructureWhenChildSameName;
  }
/**
 * @return {?}
 */
get needCheckBox(): boolean {
    return this.svc.Configuration.isHierarchy() && this.svc.Configuration.allowMultiple;
  }
/**
 * @return {?}
 */
public get haveChildren(): boolean {
    if (this.restructureWhenChildSameName && this.item && this.item.children
       && this.item.children.length === 1 && this.item.text === this.item.children[0].text) {
      this.item = this.item.children[0];
    }
    return this.item && this.item.children && this.item.children.length > 0;
  }
/**
 * @param {?} $event
 * @return {?}
 */
public select($event: any): void {
    $event.stopPropagation();
    if (this.svc.Configuration.allowMultiple ||
        !this.haveChildren ||
        this.svc.Configuration.allowParentSelection) {
      this.svc.toggleItemSelection(this.item);
    }
    this.onTouchedCallBack();
  }
/**
 * @return {?}
 */
public get filter(): string {
    return this.svc.Configuration.filter;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'tree-select-item',
  templateUrl: './tree-select-item.component.html',
  styleUrls: ['./tree-select-item.component.scss']
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SelectService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'onTouchedCallBack': [{ type: Input },],
'item': [{ type: Input },],
};
}

function TreeSelectItemComponent_tsickle_Closure_declarations() {
/** @type {?} */
TreeSelectItemComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TreeSelectItemComponent.ctorParameters;
/** @type {?} */
TreeSelectItemComponent.propDecorators;
/** @type {?} */
TreeSelectItemComponent.prototype.onTouchedCallBack;
/** @type {?} */
TreeSelectItemComponent.prototype.item;
/** @type {?} */
TreeSelectItemComponent.prototype.svc;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
